export default "__VITE_ASSET__bhHtmuDY__"